import $ from 'jquery';

$.addInit(function(context){
	var base = '.b-homePoster';
	$(base, context).each(function(){
		var component = $(this);

		component.addClass('m-animate');
	});
});
